<template>
  <transition name="el-fade-in-linear">
	  <div v-show="transitionshow">      
	  	
		    <el-dialog title="查看商品信息" :visible.sync="showgoodslists" top="5vh" width="60%" :before-close="closeproduct">
            <el-form :inline="true" class="demo-form-inline" size="small">
                <el-form-item>
                    <el-select v-model="query.agentbrandid" clearable remote  filterable placeholder="按品牌" @change="query.ischange=true">	            
                          <el-option v-for="(item,index) in brandlists" :label="item.showlable" :value="item.id" :key="index">
                            <span style="float: left">{{item.name}}</span>
                            <span style="float: right; color: #C0C4CC; font-size: 13px">{{item.py}}</span>
                          </el-option>              
                    </el-select>          
                </el-form-item>
                <el-form-item>
                    <el-input placeholder="请输入关键字" v-model="query.key" clearable @keyup.enter.native="getmatchgoods" @change="query.ischange=true" style="width:100%"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="getmatchgoods">查询</el-button>
                </el-form-item>
            </el-form>
            <el-table :data="lists" v-loading="query.loading">
                <el-table-column prop="id" label="id" />
                <el-table-column prop="name" label="商品名称" />
                <el-table-column prop="spec" label="规格" />
                <el-table-column prop="number" label="编号" />
                <el-table-column width="120" label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button type="success" size="small" circle icon="el-icon-check" @click="getgoods(scope.row)"/> 
                    </template>
                </el-table-column>
            </el-table>
            <div class="block">
                <!--分页begin-->
                <el-pagination
                    @size-change="pageProductSizeChange"
                    @current-change="pageProductCurrentChange"
                    :current-page="query.p"
                    :page-sizes="[10, 20, 50]"
                    :page-size="query.rollpage"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="query.rows">
                </el-pagination>
                <!--分页end-->
            </div>
        </el-dialog>

    </div>
  </transition>  
</template>

<script>

export default {
  props: ["value"],
  data () {
    return {
        url:this.GLOBAL.domain+"Tmall/index",
        actionauth:'', //功能权限
		    transitionshow:true,
        showgoodslists:false,
        brandlists:[],
        brandquery: {
            act:'lists',
            token:this.$cookies.get('token'),
            jdshow:0,
            rollpage:100000,
            rows:0,
	      },
        query: {
            act:'getproductlists',
            token:this.$cookies.get('token'),
            agentbrandid:'',
            key:'',
            p:1,
            rollpage:10,
            loading:false,
            ischange:false,
            rows:0
        },
        lists:[],

    }
  },
    
  mounted(){  
      this.getBrand(); //获取品牌信息
  },

  watch: {
	    value(val) {
          if(val) {
            this.showgoodslists=true;
            this.goodsreset(); //重置商品搜索参数
            this.getmatchgoods(); //获取商品信息列表
          }
      },
  },
  
  methods:{

      /** 选择商品信息 **/
      getgoods(item) {
          this.$emit('finish',item);
          this.closeproduct();
      },

      /** 重置商品信息 **/
      goodsreset() {
          this.query.agentbrandid='';
          this.query.key='';
          this.query.p=1;
          this.query.rollpage=10;
      },

      /** 获取商品信息列表 **/
      getmatchgoods() {
          if(this.query.ischange) {
              this.query.p=1;
              this.query.rollpage=10;
          }

          this.query.loading=true;
          var resource = this.$resource(this.url);		    
          resource.query(this.query).then((res) => {
          if(res.data.Result>0){
              if(res.data.Result=='70001') this.$router.push('/login')
              this.$message.error(res.data.Message);
              this.query.loading=false;
          }else{
              this.lists = JSON.parse(Base64.decode(res.data.Data));
              this.query.rows=parseInt(res.data.count);
              this.query.loading=false;
              if(this.query.ischange) this.query.ischange=false;
          }
          }).catch((res) => {
              this.$message.error(this.GLOBAL.errortext);
              this.query.loading=false;
          });
      },


      pageProductSizeChange(val) {
        this.query.rollpage = val;
        this.getmatchgoods();
      },
      pageProductCurrentChange(val) {
          this.query.p = val;
          this.getmatchgoods();
      },


      /** 获取品牌 **/
      getBrand(){
          var resource = this.$resource(this.GLOBAL.domain+"Brand/index");		    
          resource.query(this.brandquery).then((res) => {
          if(res.data.Result>0){
              if(res.data.Result=='70001') this.$router.push('/login')
              this.$message.error(res.data.Message);
          }else{
              this.brandlists = JSON.parse(Base64.decode(res.data.Data));
          }
          }).catch((res) => {
              this.$message.error(this.GLOBAL.errortext);
          });
      },
      
      closeproduct() {
          this.showgoodslists=false;
          this.$emit("close");
      },

  } 
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
</style>


// WEBPACK FOOTER //
// src/components/tmall/search/product.vue